import { useEffect, useState } from 'react'
import cn from 'classnames'
import Image from 'next/legacy/image'
// Components
import styles from './Selector.module.scss'
import OutsideClickHandler from 'react-outside-click-handler'

export default function Select({
  options: _options = [],
  value,
  placeholder,
  onChange,
  disabled,
  theme,
  showError,
  errorMessage,
  hasImage,
  // Filterable
  isFilterable,
  // Multiple
  isMultiple: _isMultiple,
  // Theme admin
  isAdmin,
}) {
  // Handles themes
  const classes = { [styles.option]: true }
  if (typeof theme === 'string') theme = [theme]
  theme?.forEach((t) => {
    classes[styles[t]] = typeof t !== 'undefined'
  })

  const [showOptions, setShowOptions] = useState(false) // Creatable
  const [filter, setFilter] = useState(value?.label || '') // Filterable

  useEffect(() => {
    if (value?.label) setFilter(value?.label)
  }, [value])
  const options = isFilterable
    ? _options?.filter((o) =>
        o.label?.toLowerCase().includes(filter.toLowerCase()),
      )
    : _options
  const isMultiple = _isMultiple && Array.isArray(value) // Multiple

  return (
    <div
      className={cn({
        [styles.container]: true,
      })}
    >
      <OutsideClickHandler
        onOutsideClick={() => {
          if (showOptions) {
            setShowOptions(false)
            if (isFilterable && value?.label) setFilter(value?.label)
          }
        }}
      >
        {value?.length > 0 && (
          <div
            className={cn({
              [styles.multiple]: true,
              [styles.input]: true,
              [styles.showError]: showError,
            })}
          >
            <div
              className={cn({
                [styles.scroll]: !isAdmin,
                [styles.square]: isAdmin,
              })}
            >
              {value.map((o, i) => (
                <div
                  key={i}
                  className={cn({
                    [styles.selected]: !isAdmin,
                    [styles.black]: isAdmin,
                  })}
                >
                  <div className={styles.label}>{o.label}</div>
                  <div
                    className={styles.clear}
                    onClick={() =>
                      onChange(
                        value.filter((selected) => selected.value !== o.value),
                      )
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        <input
          className={cn({
            [styles.margin]: isMultiple && !value.length,
            [styles.showError]: showError,
          })}
          type="text"
          placeholder={placeholder}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          onClick={() => {
            setShowOptions(true)
          }}
        />
        <br />
        {/* Modal */}
        {showOptions && (
          <div className={styles.optionsContainer}>
            <div className={styles.arrow} />
            <div
              className={cn({
                [styles.options]: true,
              })}
            >
              {options.length ? (
                options.map((o, i) => (
                  <div
                    key={i}
                    className={cn({
                      ...classes,
                      [styles.current]: isMultiple
                        ? value
                            .map((selected) => selected.value)
                            .includes(o.value)
                        : o?.value === value?.value,
                      [styles.disabled]: disabled,
                    })}
                    onClick={() => {
                      if (isMultiple) {
                        if (
                          value
                            .map((selected) => selected.value)
                            .includes(o.value)
                        ) {
                          setShowOptions(false)
                        } else {
                          if (!disabled) onChange([...value, o])
                          setShowOptions(false)
                        }
                        if (isFilterable) setFilter('')
                      }
                    }}
                  >
                    {/* Option has image */}
                    {hasImage && (
                      <div className={styles.image}>
                        {o.image ? (
                          <Image
                            src={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${o.image}`}
                            layout="fill"
                            objectFit="cover"
                            loading="lazy"
                            alt={o.label}
                          />
                        ) : null}
                      </div>
                    )}
                    <div className={styles.label}>{o.label}</div>
                  </div>
                ))
              ) : (
                <div className={styles.empty}>
                  <div className={styles.icon} />

                  <div className={styles.message}>No options found</div>
                </div>
              )}
            </div>
          </div>
        )}

        {showError && !!errorMessage && (
          <div className={styles.error}>
            <div className={styles.icon} />
            <div className={styles.message}>{errorMessage}</div>
          </div>
        )}
      </OutsideClickHandler>
    </div>
  )
}
